import type { MeetingViewMeetingNodeNewPageFragmentFragment } from "types/graphql-schema";

export const getOptimisticFinalizedAgenda = (
  agendaTopics: MeetingViewMeetingNodeNewPageFragmentFragment["agendaTopics"],
  isFinalized: boolean,
) =>
  agendaTopics.map((occurrence) => ({
    ...occurrence,
    canUpdate: {
      ...occurrence.canUpdate,
      permission: isFinalized ? false : occurrence.canUpdate.permission,
    },
    // A carried topic's canonical permissions belong to its source meeting.
    topic: occurrence.isPinned
      ? occurrence.topic
      : {
          ...occurrence.topic,
          canUpdate: {
            ...occurrence.topic.canUpdate,
            permission: isFinalized
              ? false
              : occurrence.topic.canUpdate.permission,
          },
          canDelete: {
            ...occurrence.topic.canDelete,
            permission: isFinalized
              ? false
              : occurrence.topic.canDelete.permission,
          },
        },
  }));
